import { useRouter } from 'next/navigation';

import { FaGift } from 'react-icons/fa6';

import { LiaLinkedinIn } from 'react-icons/lia';
import { RiFacebookFill, RiInstagramLine } from 'react-icons/ri';

import { UserKYCLevel } from '@/enums/core';
import { routes } from '@/features/v2/constants/routes';
import { core } from '@/features/v2/home/components/privateHome/components/cardCarousel/localization/core';
import { useAuthStore } from '@/stores/userStore';
import { userUIStore } from '@/stores/userUIStore';
import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

export const CardReferalsAdapter = () => {
  const { account } = useAuthStore();
  const { setAlert } = userUIStore();
  const referralCode = account?.topup_id || '';
  const dominio = typeof window !== 'undefined' ? window.location.hostname : '';
  const referralLink = `https://${dominio}/register/aff/ref?referral=${referralCode}`;
  const referralLinkEncoded = encodeURIComponent(referralLink);
  const ShareIcons = [{
    Icon: RiFacebookFill,
    name: 'Facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${referralLinkEncoded}`,
  }, {
    Icon: LiaLinkedinIn,
    name: 'LinkedIn',
    url: `https://www.linkedin.com/sharing/share-offsite/?url=${referralLinkEncoded}`,
  },
  {
    Icon: RiInstagramLine,
    name: 'Instagram',
    url: `https://www.instagram.com/sharer/sharer.php?u=${referralLinkEncoded}`,
  },
  ];
  const handleShare = (url: string) => {
    if (account?.kycLevel === UserKYCLevel.APPROVED) {
      window.open(url, '_blank');
    } else {
      setAlert({
        type: 'warning',
        message: 'Debes completar Verificar tu identidad para poder compartir',
        show: true,
        duration: 3000,
      });
    }
  };
  const router = useRouter();
  return (
    <div className="flex flex-col gap-4 px-2 w-72 h-60">
      <div
        className="flex bg-hbackground rounded-lg p-1 pr-3 items-center gap-4 w-2/3"
      >
        <span className="bg-primary-500 flex justify-center items-center rounded-sm p-1">
          <FaGift size={20} className="text-black" />
        </span>
        <span className="font-medium text-sm capitalize text-primary-900">
          {core.cardsCarousel[0].boxTitle}
        </span>
      </div>
      <h4 className="text-2xl font-bold text-primary-900 px-3 font-title">
        {core.cardsCarousel[0].title}
        <span className="text-primary-500">
          {core.cardsCarousel[0].tilteSpan}
        </span>
      </h4>
      <p className="text-base text-primary-900 px-3 font-text leading-tight">
        {core.cardsCarousel[0].text}
        <span className="font-bold px-1">
          {core.cardsCarousel[0].textSpan}
        </span>
        {core.cardsCarousel[0].continueText}
      </p>
      <div className="flex gap-4 px-3 mt-2">
        {ShareIcons.map(({ Icon, name, url }) => {
          return (
            <button
              type="button"
              key={name}
              className="flex justify-center items-center bg-default-800 rounded-full p-1 w-10 h-10"
              aria-label={name}
              tabIndex={0}
              onClick={() => {
                handleShare(url);
              }}
            >
              <Icon size={25} className="text-black" />
            </button>
          );
        })}
      </div>
      <div className="absolute bottom-6 w-40 left-2">
        <HButton
          mode="secondary"
          size="large"
          label="Saber más"
          disabled={false}
          onPress={() => {
            router.push(routes.REFERALS);
          }}
        />
      </div>

    </div>
  );
};

export default CardReferalsAdapter;
